import {
  faCube,
  faDesktop,
  faForward,
  faGear,
  faMobileScreen,
  faServer,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import React, { useContext, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import { NavLink } from "react-router-dom";
import VisibilitySensor from "react-visibility-sensor";
import angular from "../../assets/images/angular.png";
import aws from "../../assets/images/aws.png";
import bootstrap from "../../assets/images/bootstrap.png";
import tailwind from "../../assets/images/tailwind.png";
import symfony from "../../assets/images/symfony.png";
import cordova from "../../assets/images/cordova.png";
import csharp from "../../assets/images/csharp.png";
import { FaCode } from "react-icons/fa";
import docker from "../../assets/images/docker.png";
import express from "../../assets/images/express.png";
import flutter from "../../assets/images/flutter.png";
import git from "../../assets/images/git.png";
import java from "../../assets/images/java.png";
import jquery from "../../assets/images/jquery.png";
import js from "../../assets/images/js.png";
import kubernates from "../../assets/images/kubernates.png";
import laravel from "../../assets/images/laravel.png";
import wordpress from "../../assets/images/wordpress.png";
import next from "../../assets/images/next.png";
import node from "../../assets/images/node.png";
import php from "../../assets/images/php.png";
import plesk from "../../assets/images/plesk.png";
import python from "../../assets/images/python.png";
import react from "../../assets/images/react.png";
import spring from "../../assets/images/spring.png";
import three from "../../assets/images/three.png";
import ts from "../../assets/images/ts.png";
import unity from "../../assets/images/unity.png";
import Spacer from "../../components/Utils/Spacer";
import TitleHome from "../../components/Utils/TitleHome";
import { Context } from "../../context";
import CardSkill from "../Skill/CardSkill";
import ContainerCardSkill from "../Skill/ContainerCardSkill";
import classes from "./Skill.module.css";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
const { width, height } = getWindowDimensions();

function SkillHome() {
  const [keyTab, setKeyTab] = useState("backend");

  const [isVisible, setIsVisible] = useState(false);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  const { debug, lang } = useContext(Context);

  if (debug) {
    console.log("render skill");
  }

  return (
    <Container fluid className={classes.bg7}>


      <Container>
        <div className="row mt-3">
          <div className="col-12 text-justify text-lg-start py-5">
            <div className="text-4 text-center py-5">
              {lang === "en" && (
                <>
                  <div className={classes.devPreTitle}>
                    <span className={classes.devPrompt}>$</span>
                    <span className={classes.devCmd}>ls ./programming-skills</span>
                    <span className={classes.devCursor} />
                  </div>
                  <h1 className={classes.textSkillsTop1}>
                    <FaCode style={{ color: "#333" }} /> <span>Programming Skills</span>
                  </h1>
                  <br />
                  Regardless of the technology used, I adapt to new languages,
                  frameworks or techniques in a short time, respecting the
                  team's guidelines. I attend many online courses that allow me
                  to update or improve my knowledge. I'm generally quick to
                  learn new technologies and be productive.
                </>
              )}
              {lang === "it" && (
                <>
                  <div className={classes.devPreTitle}>
                    <span className={classes.devPrompt}>$</span>
                    <span className={classes.devCmd}>ls ./programming-skills</span>
                    <span className={classes.devCursor} />
                  </div>
                  <h1 className={classes.textSkillsTop1}>
                    <FaCode style={{ color: "#333" }} /> <span>Programming Skills</span>
                  </h1>
                  <br />
                  Indipendentemente dalla tecnologia utilizzata, mi adeguo a
                  nuovi linguaggi, framework o tecniche in breve tempo,
                  rispettando le linee guida del team. Frequento molti corsi
                  online che mi permettono di aggiornare o migliorare le mie
                  conoscenze. In genere sono veloce nell'apprendere nuove
                  tecnologie ed essere produttivo.
                </>
              )}
            </div>
          </div>
        </div>

        <Spacer height="1"></Spacer>

        <Row>
          <Col xs={12} lg={12}>
            <Tabs
              id="controlled-tab-example"
              activeKey={keyTab}
              onSelect={(k) => {
                if (k !== keyTab) {
                  setKeyTab(k);
                  setIsVisible(false);
                }
              }}
              className={classes.nowrap + " mb-3"}
            >
              <Tab
                eventKey="backend"
                title={
                  <div className={`${classes.tabMobile} ${keyTab === "backend" ? classes.tabActive : ""}`}>
                    <FontAwesomeIcon icon={faServer} />
                    <span>Backend</span>
                  </div>
                }
              >
                <VisibilitySensor
                  onChange={changeVisibility}
                  partialVisibility
                  delayedCall
                >
                  <ContainerCardSkill>
                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.2 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill text="php" classCard="php" img={php} />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.4 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill
                        text="laravel"
                        classCard="laravel"
                        img={laravel}
                      />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.5 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill text="symfony" classCard="symfony" img={symfony} />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.8 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill text="node.js" classCard="node" img={node} />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 1 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill
                        text="express"
                        classCard="express"
                        img={express}
                      />
                    </motion.div>
                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 1.4 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill text="java" classCard="java" img={java} />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 1.8 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill
                        text="spring"
                        classCard="spring"
                        img={spring}
                      />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 2.2 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill
                        text="python"
                        classCard="python"
                        img={python}
                      />
                    </motion.div>

                  </ContainerCardSkill>
                </VisibilitySensor>
              </Tab>

              <Tab
                eventKey="frontend"
                title={
                  <div className={`${classes.tabMobile} ${keyTab === "frontend" ? classes.tabActive : ""}`}>
                    <FontAwesomeIcon icon={faDesktop} />
                    <span>Frontend</span>
                  </div>
                }
              >
                <VisibilitySensor
                  onChange={changeVisibility}
                  partialVisibility
                  delayedCall
                >
                  <ContainerCardSkill>
                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.2 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill
                        text="react.js"
                        classCard="react"
                        img={react}
                      />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.3 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill text="next.js" classCard="nextjs" img={next} />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.4 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill
                        text="angular.js"
                        classCard="angular"
                        img={angular}
                      />
                    </motion.div>

                  

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.5 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill
                        text="javascript"
                        classCard="js"
                        img={js}
                        blackText
                      />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.6 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill text="typescript" classCard="ts" img={ts} />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.7 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill
                        text="jquery"
                        classCard="jquery"
                        img={jquery}
                      />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.8 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill
                        text="bootstrap"
                        classCard="bootstrap"
                        img={bootstrap}
                      />
                    </motion.div>

                      <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.45 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill
                        text="tailwind"
                        classCard="tailwind"
                        img={tailwind} // Placeholder
                      />
                    </motion.div>


                  </ContainerCardSkill>
                </VisibilitySensor>
              </Tab>

              <Tab
                eventKey="app"
                title={
                  <div className={`${classes.tabMobile} ${keyTab === "app" ? classes.tabActive : ""}`}>
                    <FontAwesomeIcon icon={faMobileScreen} />
                    <span>App</span>
                  </div>
                }
              >
                <VisibilitySensor
                  onChange={changeVisibility}
                  partialVisibility
                  delayedCall
                >
                  <ContainerCardSkill>
                    <ContainerCardSkill>
                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="react native"
                          classCard="react"
                          img={react}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.4 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="flutter"
                          classCard="flutter"
                          img={flutter}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.6 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="cordova"
                          classCard="express"
                          img={cordova}
                        />
                      </motion.div>
                    </ContainerCardSkill>
                  </ContainerCardSkill>
                </VisibilitySensor>
              </Tab>

              <Tab
                eventKey="3d"
                title={
                  <div className={`${classes.tabMobile} ${keyTab === "3d" ? classes.tabActive : ""}`}>
                    <FontAwesomeIcon icon={faCube} />
                    <span>Web 3D</span>
                  </div>
                }
              >
                <VisibilitySensor
                  onChange={changeVisibility}
                  partialVisibility
                  delayedCall
                >
                  <ContainerCardSkill>
                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.2 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill
                        text="three.js"
                        classCard="three"
                        img={three}
                      />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.4 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill
                        text="react fiber"
                        classCard="react"
                        img={react}
                      />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.6 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill text="unity" classCard="express" img={unity} />
                    </motion.div>
                  </ContainerCardSkill>
                </VisibilitySensor>
              </Tab>

              <Tab
                eventKey="gear"
                title={
                  <div className={`${classes.tabMobile} ${keyTab === "gear" ? classes.tabActive : ""}`}>
                    <FontAwesomeIcon icon={faGear} />
                    <span>DevOps</span>
                  </div>
                }
              >
                <VisibilitySensor
                  onChange={changeVisibility}
                  partialVisibility
                  delayedCall
                >
                  <ContainerCardSkill>
                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.2 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill text="plesk" classCard="express" img={plesk} />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.4 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill text="aws" classCard="express" img={aws} />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.6 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill text="git" classCard="git" img={git} />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 0.8 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill
                        text="docker"
                        classCard="docker"
                        img={docker}
                      />
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                        y: isVisible ? 0 : 20,
                      }}
                      transition={{ duration: 0.4, delay: 1 }}
                      className={classes.CardExternal}
                    >
                      <CardSkill
                        text="kubernates"
                        classCard="kubernates"
                        img={kubernates}
                      />
                    </motion.div>
                  </ContainerCardSkill>
                </VisibilitySensor>
              </Tab>

              <Tab
                eventKey="Others"
                title={
                  <div className={`${classes.tabMobile} ${keyTab === "Others" ? classes.tabActive : ""}`}>
                    <FontAwesomeIcon icon={faForward} />
                    <span>Others</span>
                  </div>
                }
              >
                <VisibilitySensor
                  onChange={changeVisibility}
                  partialVisibility
                  delayedCall
                >
                  <ContainerCardSkill>
                    <ContainerCardSkill>
                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="python"
                          classCard="python"
                          img={python}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="c sharp"
                          classCard="csharp"
                          img={csharp}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill text="java" classCard="java" img={java} />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill text="unity" classCard="express" img={unity} />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.3 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="wordpress"
                          classCard="wordpress"
                          img={wordpress}
                        />
                      </motion.div>
                    </ContainerCardSkill>
                  </ContainerCardSkill>
                </VisibilitySensor>
              </Tab>
            </Tabs>
          </Col>
        </Row>
        <Spacer height="70" />

        <VisibilitySensor
          onChange={changeVisibility}
          partialVisibility
          delayedCall
        >
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{
              opacity: isVisible ? 1 : 0,
              y: isVisible ? 0 : 20,
            }}
            transition={{ duration: 0.6, delay: 1.3 }}
          >
            <NavLink
              to="/skill"
              className={
                classes.projectButton + " nav-link smooth-scroll text-center"
              }
            >
              <span className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll">
               
                {lang === "en" && (
                  <>
                  
                    View all details
                  </>
                )}
                {lang === "it" && (
                  <>
                    Visualizza tutto
                  </>
                )}

              </span>
            </NavLink>
          </motion.div>
        </VisibilitySensor>
        <Spacer height="100"></Spacer>
      </Container>
    </Container >
  );
}

export default SkillHome;
